import React, { useState } from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { StyledCard, CardTitle, CollapsePanelHeader } from '../style'
import ApprovationsTable from './ApprovationsTable'

interface Props {
  productId?: number
}

const Aprovations: React.FC<Props> = ({ productId }) => {
  const [isOpen, setIsOpen] = useState(false)
  const hasProduct = typeof productId === 'number' && !Number.isNaN(productId) && productId > 0

  return (
    <StyledCard>
      <CollapsePanelHeader
        $open={isOpen}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <CardTitle>Aprovações</CardTitle>
        {isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
      </CollapsePanelHeader>
      {isOpen && (
        hasProduct ? (
          <ApprovationsTable productId={productId as number} />
        ) : (
          <div
            style={{
              padding: '16px 4px',
              color: '#6b7280',
              fontSize: 13,
            }}
          >
            Salve o produto para começar a cadastrar aprovações.
          </div>
        )
      )}
    </StyledCard>
  )
}

export default Aprovations
